import { EWhiteLabelFont } from '../white-label-fonts.enum';
import { TWhiteLabelPanelColors, TWhiteLabelPrimaryColors } from '../white-label.model';

export const DEFAULT_ORIGINAL_FONT_FAMILY = EWhiteLabelFont.SOURCE_SANS_PRO;
export const DEFAULT_FONT_FAMILY = EWhiteLabelFont.PLUS_JAKARTA_SANS;

export const DEFAULT_ORIGINAL_PRIMARY_COLORS: TWhiteLabelPrimaryColors = {
  primary50: '#F5FAFF',
  primary75: '#EBF5FF',
  primary100: '#CCE6FE',
  primary200: '#A3D3FC',
  primary300: '#7ABFFB',
  primary400: '#52ABFA',
  primary500: '#2E9DFF',
  primary600: '#0084F8',
  primary700: '#006FD0',
  primary800: '#005AA9',
  primary900: '#004581',
  primary950: '#0084F8',
};

export const DEFAULT_PRIMARY_COLORS: TWhiteLabelPrimaryColors = {
  primary50: '#FFF3FF',
  primary75: '#FFEFFF',
  primary100: '#FFEFFF',
  primary200: '#FEE5FF',
  primary300: '#F9D4FF',
  primary400: '#EFBDFF',
  primary500: '#daa9f0',
  primary600: '#c191d7',
  primary700: '#A475B9',
  primary800: '#845798',
  primary900: '#613573',
  primary950: '#421653',
};

export const DEFAULT_ORIGINAL_PANEL_COLORS: TWhiteLabelPanelColors = {
  panelBg: '#1D2939',
  panelAccent: '#344054',
  panelFont: '#2E9DFF',
  panelFontHighlight: '#2E9DFF',
  panelText: '#ffffff',
  panelTextHover: '#FFFFFF',
  iconActiveColorPanel: '#ffffff',
  itemBorder: '#ffffff',
  itemBgHover: '#1D2939',
};

export const DEFAULT_PANEL_COLORS: TWhiteLabelPanelColors = {
  panelBg: '#FAFAFA',
  panelAccent: '#FFFFFF',
  panelFont: '#F4F4F5',
  panelFontHighlight: '#752E73',
  panelText: '#52525B',
  panelTextHover: '#52525B',
  iconActiveColorPanel: '#ffffff',
  itemBorder: '#d4d4d8',
  itemBgHover: '#d4d4d8',
};
